export default (pathname: string, route: string) => {
    return pathname.slice(0, route.length + 1) === "/" + route;
};
